
import { ACTION, actionKeyGenerate, GenericObject } from "src/util/utils";

export const MODULE_KEY = "UNDO_INVENTORY_POST";

export const KEYS: GenericObject = actionKeyGenerate(MODULE_KEY);

export const FETCH_INVENTORY_LOCATIONS_FETCH = KEYS[MODULE_KEY + ACTION.FETCH];

export const fetchInventoryPostLocationsRequest = () => ({
  type: FETCH_INVENTORY_LOCATIONS_FETCH,
});

export const fetchInventoryLocationsSuccess = (payload: any) => ({
  type: KEYS[MODULE_KEY + ACTION.SUCCESS],
  payload,
});

export const fetchInventoryLocationsFailure = (error: any) => ({
  type: KEYS[MODULE_KEY + ACTION.FAILED],
  error,
});